declare function require(name:string): any;




require('element-qsa-scope'); // https://github.com/jonathantneal/element-qsa-scope



import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

/** jQuery */
import * as $ from 'jquery';
// @ts-ignore: next line
window['jQuery'] = $; // Attach to window for use outside the bundle

require('./lib/jquery-ui.js');
require('./lib/jquery.cycle2.js');
require('./lib/jquery.hoverIntent.js');

require('./lib/Forms.js').init();

import articleSearch from './forms/articleSearch';
articleSearch();

import newsletterSubscriptionForm from './forms/newsletterSubscriptionForm';
newsletterSubscriptionForm();

/** Pre-Gulp scripts */
require('./lib/legacy.site.js');

/** Others */
require('./components/lightbox.js').init();
require('./components/MegaMenu.js').init();
require('./components/ImageGrid.js').init();
require('./contentElement/containerBlock/FileList.js').init();

/* Masthead with slides */
import MastheadCarousel from './components/Carousel';
const carouselEl = document.querySelector('.masthead--withSlides') as HTMLElement;
if (carouselEl) {
	const entryCarousel = new MastheadCarousel({
		carouselClass: 'masthead',
		carouselEl: carouselEl,
		duration: 7500,
		doIndicators: true,
		doIndicatorClick: true,
	});
}

/* TODO Should setup site with a componentManager similiar to plaudit.com. This for-loop is a temporary implementation to make Accordion work. */
const Accordion = require('./components/Accordion.js');
const accordionElems = document.getElementsByClassName(Accordion.COMPONENT_STYLE_CLASS);
for (var i=0; i < accordionElems.length; i++) {
	var elem = accordionElems[i];
	new Accordion(elem);
}

require('./forms/emailSignatureGenerator.js').init();

require('./layout/survey.js').init();

import jobFileManager from './components/jobFileManager';
jobFileManager();

/* ========================================================
 * 		Setup
 ========================================================= */

 // TODO This code all needs a lot updating and cleanup.
